
export const createLoadingSelector = actions => state =>
  actions.some(action => {
    return state.loading[action]
  });